import { mdiHospitalBuilding } from '@mdi/js';
import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { BadgeIcon } from './badge-icon';
import { generateLabel, withNpi } from './util';

export interface IFacilityBadgeProps {
    className?: string;
    id?: string;
    name?: string;
    npi?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const FacilityBadge: React.FunctionComponent<IFacilityBadgeProps> = (
    props: IFacilityBadgeProps,
): React.ReactElement => {
    const { className, id, name, npi, tooltip, items } = props;
    return (
        <ActionMenuBadge
            className={className}
            label={withNpi(generateLabel('Facility', id, name), npi)}
            tooltip={tooltip}
            items={items}
            id={id}
            Symbol={<BadgeIcon path={mdiHospitalBuilding} />}
        />
    );
};
